import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rIstatistikSonuc_3, rValue } from '../../models/.catalog';

export default class DegerlemeToplamDegerApi extends ApiBase<pList, rValue<rIstatistikSonuc_3>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/DegerlemeToplamDeger',
      }),
      options
    );
  }
}
